import type { FC } from 'react'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import type { UseCase } from '@segment/api/routes/useCases/types'

import Card from '../Card'
import CardsGroup from '../CardsGroup'
import CardsSection from '../CardsSection'

interface UseCasesGridProps {
  useCases?: UseCase[]
}
const UseCasesGrid: FC<UseCasesGridProps> = ({ useCases }) => {
  const isEmpty = !useCases || useCases.length === 0

  return (
    <CardsSection isEmpty={isEmpty}>
      <CardsGroup data-testid="cards-grid" aria-live="polite">
        {useCases?.map(({ title, useCase, description, url }) => (
          <Card key={title} useCase={useCase} title={title} description={description} url={url} />
        ))}
      </CardsGroup>
      {isEmpty && (
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h4" variant="h4">
            Sorry, no results found.
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pMedium">
            Please try selecting different filters.
          </CopyText.Description>
        </CopyTextBase>
      )}
    </CardsSection>
  )
}

export default UseCasesGrid
